module.exports = __webpack_public_path__ + "img/20230201.e830670a.png";